var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',{staticClass:"label-asterisk text-danger"},[_vm._v("*")])}
var staticRenderFns = []

export { render, staticRenderFns }